import type { CSSProperties, ReactNode } from 'react';

export interface DividerProps {
    orientation?: 'horizontal' | 'vertical';
    label?: ReactNode;
    /** Margem no eixo da separação, em px. */
    spacing?: number;
    style?: CSSProperties;
}

export function Divider({ orientation = 'horizontal', label, spacing = 16, style }: DividerProps) {
    if (orientation === 'vertical') {
        return <span style={{ width: 1, alignSelf: 'stretch', background: 'var(--border-subtle)', margin: `0 ${spacing}px`, ...style }} />;
    }
    if (label) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: `${spacing}px 0`, ...style }}>
                <span style={{ flex: 1, height: 1, background: 'var(--border-subtle)' }} />
                <span style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-tertiary)', letterSpacing: 'var(--tracking-wide)', textTransform: 'uppercase' }}>{label}</span>
                <span style={{ flex: 1, height: 1, background: 'var(--border-subtle)' }} />
            </div>
        );
    }
    return <hr style={{ border: 0, height: 1, background: 'var(--border-subtle)', margin: `${spacing}px 0`, ...style }} />;
}
